G.MysteryGiftHeader = function(peak) {
  Phaser.Group.call(this, game);
  this.fixedToCamera = true;

  var txt;

  if (G.saveState.mysteryGift_getCurrentStreak() >= 3) {
    txt = OMT.language.getText("Continue winning with one try to keep your boosters!");
  } else if (G.saveState.mysteryGift_getCurrentStreak() < 3 && peak) {
    txt = OMT.language.getText("Win this level now and get a cool mystery gift!")
  } else {
    txt = OMT.language.getText("Finish with one try");
  }

  //no peak, and no streak so far, so there is no risk
  if (!peak && G.saveState.mysteryGift_getCurrentStreak() === 0) {
    this.visible = false;
  }

  this.msg = game.add.group(this);
  this.msg.name = "message";
  this.msg.y = -200;


  this.bg = G.makeImage(0, 0, "First_try_bar", [0.5, 0], this.msg);
  this.bg.width = 640;

  // this._giftIcon = G.makeImage(163, -7, "MysteryGift_small", 0.5, this);
  this.text = new G.Text(0, 37, txt, {
    style: "window-blue",
    fontSize: '30px',
    lineSpacing: -5,
  }, 0.5, 490, 75, true, 'center');
  this.msg.add(this.text);

  // Add timer
  const style = {
    style: G.saveState.mysteryGift_getRemainingGiftCooldown() > 0 ? "mysteryGift-timer-yellow" : "mysteryGift-timer-red",
    fontSize: '24px',
  }
  this.timer = new G.TextTimer(300, 72, null, style, [1, 1], 120, "ms");
  this.msg.add(this.timer);

  let secLeft = Math.floor(G.saveState.mysteryGift_getRemainingGiftCooldown()/1000);
  this.timer.setSecLeft(secLeft);
  this.timer.active = true;

  G.Utils.cleanUpOnDestroy(this, 
    G.sb("onScreenResize").add(this.onResize, this));

  this.onResize();
};

G.MysteryGiftHeader.prototype = Object.create(Phaser.Group.prototype);

G.MysteryGiftHeader.prototype.onResize = function() {
  this.cameraOffset.x = Math.floor(game.width * 0.5);
  this.cameraOffset.y = 0;
};

G.MysteryGiftHeader.prototype.show = function() {
  var animation = G.Animations.getMysteryGiftHeaderShow();
  animation.animate(game, this.msg);
};
  
G.MysteryGiftHeader.prototype.hide = function(optOnComplete) {
  var animation = G.Animations.getMysteryGiftHeaderHide();
  animation.animate(game, this.msg);
  if (optOnComplete) {
    animation.onComplete.add(optOnComplete);
  }
};